import React from "react";
import { Navigation, Pagination, Autoplay } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "./Team.css";
import "swiper/css/effect-fade";
import "swiper/css/effect-cube";
import "swiper/css/effect-coverflow";
import "swiper/css/effect-flip";

const founders = [
  { name: "Deepa Bassapur", role: "Founder", qualification: "B.Ed.", image: "./Assests/Deepa_b.jpeg", linkedin: "" },
];

const directors = [
  { 
    name: "Prashant Subhedar", 
    role: "Head of Operations", 
    qualification: "M.Sc., M.Ed.",
    qualification2: "Assistant Lecturer at MTTI College, Belagavi", 
    image: "./Assests/Prashant_S.png", 
    linkedin: "" 
  },
  { 
    name: "Manju Mehra", 
    role: "Vice President", 
    qualification: "Chief Specialist in Cyber Psychology,", 
    qualification2: "Forensic Psychology, and Cyber Security",
    image: "./Assests/Manju_M.jpeg", 
    linkedin: "" 
  },
  { name: "Shridhar Bassapur", role: "IT Lead", qualification: "", image: "./Assests/Shashidar.jpeg", linkedin: "" },
];

const advisoryMembers = [
  { name: "Santosh Kushte", role: "Advisory Member", qualification: "Diploma in Mechanical Engineering", image: "./Assests/Santosh.jpeg", linkedin: "" },
  { name: "Shrinivas Dhotre", role: "Advisory Member", qualification: "Diploma in Automobile Engineering", image: "./Assests/No_Image.png", linkedin: "" },
  { name: "Praveen Patil", role: "Advisory Member", qualification: "", image: "/Assests/Praveen_P.jpeg", linkedin: "" },
  { name: "Dr. Sri Shrirang Joshi", role: "Advisory Member", qualification: "B.Sc. IDD (DT)", image: "/Assests/Joshi.jpeg", linkedin: "" },
];

const volunteeringMembers = [
  { name: "Prem Harni", role: "Volunteering Member", qualification: "Pursuing BE in Electronics and Communication Engineering", image: "./Assests/Prem.png", linkedin: "" },
  { name: "Suraj Nilazkar", role: "Volunteering Member", qualification: "Pursuing MCA", image: "./Assests/Suraj.jpeg", linkedin: "https://www.linkedin.com/in/suraj-satish-nilajkar-2796b8202/?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app" },
  { name: "Anish Belekar", role: "Volunteering Member", qualification: "BCA in GSS", image: "./Assests/Anish.jpg", linkedin: "https://www.linkedin.com/in/anish-belekar-034080244/" },
  { name: "Sachin Basme", role: "Volunteering Member", qualification: "BE in Electronics & Communication", image: "/Assests/Sachin_B.jpg", linkedin: "https://www.linkedin.com/in/sachinbhasme/" },
  { name: "Chetan", role: "Volunteering Member", qualification: "BCS", image: "./Assests/No_Image.png", linkedin: "" },
  { name: "Sameer Salgudi", role: "Volunteering Member", qualification: "Pursuing BE in Mechanical Engineering", image: "/Assests/Sameer.jpeg", linkedin: "https://www.linkedin.com/in/sameer-salgudi-069350260/?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app" },
  { name: "Ajay", role: "Volunteering Member", qualification: "Pursuing Diploma in Electrical & Electronics Engineering", image: "./Assests/Ajay.jpeg", linkedin: "" },
  { name: "Ananda", role: "Volunteering Member", qualification: "M.Sc.", image: "/Assests/Anand_h.jpeg", linkedin: "https://www.linkedin.com/in/anand-hampannavar-ecommerce-specialist/?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app" },
];

const staffMembers = [
  { name: "Leela Lamani", role: "Teaching & Admin Head", qualification: "BBA", image: "./Assests/Leela_L.jpeg", linkedin: "https://www.linkedin.com/in/leela-lamani-45a175193/?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app" },
  { name: "Pratik Bamani", role: "Technical Head", qualification: "Pursuing MCA at GIT", image: "./Assests/Pratik.jpeg", linkedin: "https://www.linkedin.com/in/pratik-bamane-369177244/?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app" },
  { name: "Kushal Kagalkar", role: "Project Coordinator", qualification: "B.Sc. in GSS College", image: "./Assests/No_Image.png", linkedin: "" },
];

const collaborations = [
  { logo: "./Assests/Arnima.png" },

];

const TeamMemberCard = ({ member, isStaff = false, isDirector = false }) => {
  const showLinkedIn = member.linkedin && member.linkedin.length > 0;
  
  return (
    <div className={isStaff ? "staff-card" : "team-member"}>
      <div className="profile-pic-container">
        <img src={member.image} alt={member.name} className="profile-pic large with-border" />
        {showLinkedIn && (
          <div className="linkedin-icon-container">
            <a href={member.linkedin} target="_blank" rel="noopener noreferrer" className="linkedin-icon-circle">
              <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="white">
                <path d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.784 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z"/>
              </svg>
            </a>
          </div>
        )}
      </div>
      <h3>{member.name}</h3>
      {isDirector ? (
        <div className="director-info">
          <p className="role-qualification director-role">{member.role} {member.qualification ? ` | ${member.qualification}` : ''}</p>
          {member.qualification2 && <p className="role-qualification director-qual">{member.qualification2}</p>}
        </div>
      ) : (
        <p className="role-qualification">
          {member.role}{member.qualification ? ` | ${member.qualification}` : ''}
        </p>
      )}
    </div>
  );
};

const TeamPage = () => {
  return (
    <div className="team-page">
      <h1 className="team-heading">Meet Our Incredible Team</h1>
      <p className="team-subheading">Passionate individuals working together to create a lasting impact</p>

      <h2 className="section-title">Founder</h2>
      <div className="team-section">
        {founders.map((member, index) => (
          <TeamMemberCard key={index} member={member} />
        ))}
      </div>

      <h2 className="section-title">Directors</h2>
      <div className="team-section coordinators compact-directors">
        {directors.map((member, index) => (
          <TeamMemberCard key={index} member={member} isDirector={true} />
        ))}
      </div>

      <h2 className="section-title">Advisory Members</h2>
      <div className="team-section staff small">
        {advisoryMembers.map((member, index) => (
          <TeamMemberCard key={index} member={member} isStaff={true} />
        ))}
      </div>

      <h2 className="section-title">Volunteering Members</h2>
      <div className="team-section staff small">
        {volunteeringMembers.slice(0, 4).map((member, index) => (
          <TeamMemberCard key={index} member={member} isStaff={true} />
        ))}
      </div>
      <div className="team-section staff small">
        {volunteeringMembers.slice(4).map((member, index) => (
          <TeamMemberCard key={index} member={member} isStaff={true} />
        ))}
      </div>

      <h2 className="section-title">Staff Members</h2>
      <div className="team-section staff small">
        {staffMembers.map((member, index) => (
          <TeamMemberCard key={index} member={member} isStaff={true} />
        ))}
      </div>

      {/* Replace the existing Collaboration section in the TeamPage component with this code */}

{/* Replace the existing Collaboration section in the TeamPage component with this code */}

<h2 className="section-title">Collaborations</h2>
{collaborations.length === 1 ? (
  <div className="collaboration-container">
    <div className="single-collaboration">
      <img src={collaborations[0].logo} alt="Collaboration Partner" className="collab-logo" />
    </div>
  </div>
) : (
  <Swiper
    modules={[Autoplay]}
    spaceBetween={5}
    breakpoints={{
      640: { slidesPerView: 1 },
      768: { slidesPerView: 2 },
      1024: { slidesPerView: 8 },
    }}
    pagination={{ clickable: true }}
    autoplay={{
      delay: 1000,
      disableOnInteraction: false
    }}
    speed={1000} 
    loop={true}
    style={{ marginTop: "15px", width: "83%" }} 
  >
    {collaborations.map((company, index) => (
      <SwiperSlide key={index}>
        <img src={company.logo} alt="Company Logo" className="collab-logo" />
      </SwiperSlide>
    ))}
  </Swiper>
)}
    </div>
  );
};

export default TeamPage;